import { useQuery } from "@tanstack/react-query";
import { usePlayerList } from "./usePlayerList.ts";

export const usePlayer = (playerId?: string) => {
  const players = usePlayerList();

  return useQuery({
    queryKey: ["player", playerId],
    queryFn: () => {
      if (!players.data) {
        throw new Error("Player list not loaded");
      }

      return players.data.find((p) => p.id === playerId);
    },
    enabled: !!playerId && players.isSuccess,
  });
};
